import { ExecuteActionResponseDto } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { publicAxios } from "../axiosInstances";
import { guestCheckoutKeys } from "../query-keys/guest-checkout.keys";

export const executeGuestAction = async (
  token: string
): Promise<ExecuteActionResponseDto> => {
  const { data } = await publicAxios.get<ExecuteActionResponseDto>(
    `/guest-checkout/actions/${token}`
  );
  return data;
};

export const useExecuteGuestAction = (token?: string) => {
  return useQuery({
    queryKey: guestCheckoutKeys.action(token!),
    queryFn: () => executeGuestAction(token!),
    enabled: !!token,
  });
};
